<template>
  <div :class="[
    'v-accordion',
    !isActive && 'v-accordion--collapsed'
  ]">
    <div class="v-accordion__header" @click="toggle()">
      {{title}}
      <svg width="14" height="14" xmlns="http://www.w3.org/2000/svg">
        <g fill="#282828" fill-rule="evenodd">
          <rect v-if="!isActive" x="6" width="2" height="14" rx="1"/>
          <rect transform="rotate(90 7 7)" x="6" width="2" height="14" rx="1"/>
        </g>
      </svg>
    </div>
    <div class="v-accordion__content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      isActive: false
    };
  },
  methods: {
    toggle() {
      this.isActive = !this.isActive;
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../sass/component.scss";

.v-accordion {
  background: theme-color("light");
  border-radius: $border-radius;
  padding: $spacer / 2;

  &__header {
    padding: $spacer / 2;
    font-weight: bold;
    cursor: pointer;
    user-select: none;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .v-accordion--collapsed & {
      font-weight: normal;
    }

    svg {
      flex: 0 0 14px;
      margin-left: $spacer;
    }
  }

  &__content {
    padding: $spacer / 2;

    .v-accordion--collapsed & {
      display: none;
    }
  }
}
</style>
